import ClassNames from "classnames";
import { FunctionComponent, RefCallback } from "react";
import headerBaseStyles from "../stylesheets/components/header-base.module.css";
import styles from "../stylesheets/components/header-layout-4.module.css";
import imageOverlayStyles from "../stylesheets/components/image-overlay.module.css";
import { CommonHeaderLayoutProps } from "../types/index.js";
import {
  getActionAndContactLinks,
  getImageModuleWithFixedAspectRatio,
} from "../utils/utils.js";
import FullHeaderOverlayBox from "./FullHeaderOverlayBox.js";
import HeaderLogo from "./HeaderLogo.js";
import Header4And5Mobile from "./HeaderMobile/Header4And5Mobile.js";
import HeaderSidebarIconNav from "./HeaderSidebarIconNav.js";
import LanguageMenu from "./LanguageMenu.js";
import LeftOverlayNav from "./LeftOverlayNav.js";
import ImagesModule from "./Modules/ImagesModule.js";

interface Props {
  intersectionTriggerRef: RefCallback<HTMLDivElement>;
  common: CommonHeaderLayoutProps;
  showMenuSeparators: boolean;
}

const HeaderLayout4: FunctionComponent<Props> = ({
  showMenuSeparators,
  intersectionTriggerRef,
  common,
  common: {
    accommodation,
    actionLinks,
    activePagePath,
    fallbackLanguageId,
    imageOverlayGradient,
    imagesModule,
    isHomePage,
    isPreview,
    languageId,
    logo,
    favicon,
    logoSize,
    useFaviconAsLogo,
    mainPageURL,
    menuItems,
    pageId,
    pages,
    queries,
    scheme,
  },
}) => {
  const headerLogo = favicon && useFaviconAsLogo ? favicon : logo;
  const navLinks = getActionAndContactLinks(
    accommodation,
    actionLinks,
    languageId,
  );

  return (
    <>
      {imagesModule?.pageId && (
        <div
          className={ClassNames(
            headerBaseStyles.HeaderModule__Inner,
            headerBaseStyles["HeaderModule__Inner--wide"],
            styles["HeaderModule__Inner--left-overlay-nav"],
            styles[
              `HeaderModule__Inner--image-overlay-gradient-${imageOverlayGradient}`
            ],
            {
              [headerBaseStyles["HeaderModule__Inner--is-home"]]: isHomePage,
              [headerBaseStyles["HeaderModule__Inner--preview"]]: isPreview,
              [headerBaseStyles["HeaderModule__Inner--full-height"]]:
                !isPreview,
            },
            imageOverlayStyles["ImageOverlay__HeaderModule--left-overlay-nav"],
          )}
        >
          <ImagesModule
            translatedModule={getImageModuleWithFixedAspectRatio(imagesModule)}
            isPreview={isPreview}
            pageId={pageId}
            queries={queries}
            isActive={false}
            isInsideHeader={true}
            isFirstOnPage={false}
            parentScheme={scheme}
            activeModuleId={undefined}
            fullHeight={!isPreview}
            sliderControlsPosition="bottom-center"
          />
          <div
            ref={intersectionTriggerRef}
            className={styles.LeftHeaderOverlay}
          >
            <LeftOverlayNav
              isPreview={isPreview}
              languageId={languageId}
              pages={pages}
              activePagePath={activePagePath}
              fallbackLanguageId={fallbackLanguageId}
              menuItems={menuItems}
              showMenuSeparators={showMenuSeparators}
            />
            <div className={styles.LeftHeaderOverlay__Box}>
              <HeaderLogo
                isPreview={isPreview}
                logo={logo}
                mainPageURL={mainPageURL}
                scheme={scheme}
                maxSize={{ width: 300, height: 100 }}
                size={logoSize}
                className={styles.LeftHeaderOverlay__HeaderLogo}
              />
              <FullHeaderOverlayBox
                className={styles.LeftHeaderOverlay__BoxInfo}
              >
                <HeaderSidebarIconNav
                  isPreview={isPreview}
                  navLinks={navLinks}
                  scheme={scheme}
                  hoverTextDirection="left"
                  iconClassName={
                    styles.LeftHeaderOverlay__HeaderSidebarIconNav__Icon
                  }
                />
                <LanguageMenu
                  isPreview={isPreview}
                  languageId={languageId}
                  scheme={undefined}
                  pageId={pageId}
                  variant="horizontal"
                  switchToSelectLimit={1}
                  className={styles.FullHeaderOverlay__LanguageMenu}
                />
              </FullHeaderOverlayBox>
            </div>
          </div>
        </div>
      )}

      <Header4And5Mobile {...common} logo={headerLogo} />
    </>
  );
};

export default HeaderLayout4;
